import { Tabs } from "./tabs";
import { Badge } from "./badge";
import { Button } from "./button";
import { Input } from "./input";
import { Text } from "./text";
import { Textarea } from "./textarea";
import { Link } from "./link";
import { Accordion } from "./accordion";
import { Select } from "./select";
import { Radio } from "./radio";
import { Switch } from "./switch";

const components = {
  Tabs,
  Badge,
  Button,
  Input,
  Text,
  Textarea,
  Link,
  Accordion,
  Select,
  Radio,
  Switch,
};

export { components };
